import React, { FC, useState, useRef, useEffect } from "react";
import {
  Container,
  NavWrapper,
  HeadWrapper,
  RightHeadContainer
} from './styles'
import { useTranslation } from "react-i18next";
import { Route, Navigate, Routes, useNavigate, useLocation, useParams } from "react-router-dom";
import { BackArrow, Button, Tabs, TopProgress, Typography } from "../../../../components";
import {
  Users,
  Details,
  Invoices,
  Journal,
  BillingHistory,
  CloudResources,
  Services,
  EmailLog,
  ClientLog,
  OpenstackService,
} from './components'
import { useUi } from "../../../../context/ui.context";
import { timeConverterMMDDYYHHMM } from "../../../../utils/dates";
import { clientService } from "../../../../api";
import { useAuth } from "../../../../context/user.context";
import { usePageTitle } from "../../../../context/navigationContext";
import EditClient from "../client-edit";

const ClientPage:FC = () => {
  const [t] = useTranslation()
  const navigate = useNavigate()
  const [client, setClient] = useState<any>()
  usePageTitle(client ? `${t("PAGE_TITLE_CLIENT_DETAIL")}: ${client}` : t("PAGE_TITLE_CLIENT_DETAIL"))
  const [activeTab, setActiveTab] = useState<string>('1')
  const location = useLocation()
  // const {setClientToInvite} = useAuth()
  useEffect(() => {
    tabs.map((item:any) => {
      if(location.pathname?.split('/').reverse()?.[0] === item.slug){
        setActiveTab(item.slug)
      }
    })
  },[location])
  const [tabs, setTabs] = useState<any[]>([
    {
      title:t("DETAILS"),
      slug:'details',
      id:'1'
    },
    {
      title:t("USERS"),
      slug:'users',
      id:'2'
    },
    {
      title:t("INVOICES"),
      slug:'invoices',
      id:'3'
    },
    {
      title:t("JOURNAL"),
      slug:'journal',
      id:'4'
    },
    {
      title:t("BILLING_HISTORY"),
      slug:'billing-history',
      id:'5'
    },
    {
      title:t("CLOUD_RESOURCES"),
      slug:'cloud-resources',
      id:'6'
    },
    {
      title:t("SERVICES"),
      slug:'services',
      id:'7'
    },
    {
      title:t("OPENSTACK_SERVICE"),
      slug:'openstack-service',
      id:'10'
    },
    {
      title:t("EMAIL_LOG"),
      slug:'email-log',
      id:'8'
    },
    {
      title:t("LOG"),
      slug:'log',
      id:'9'
    },
  ])
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const { userId } = useParams();
  const {viewAlert} = useUi()
  console.log('userId', userId);
  useEffect(() => {
    if(userId){
      clientService.getClient(userId)
      .then((res) => {
        setClient(`${res.data.first_name} ${res.data.last_name}`)
        // setClientToInvite(res.data)
      })
      .catch((e) => {
        if(e?.response?.data?.detail){
          viewAlert({
            severity:'error',
            message:e?.response?.data?.detail
          })
        }
      })
      .finally(() => {
        setPageLoading(false)
      })
    }
  },[])
  return(
    <Container>
      {/* <TopProgress/> */}
      {pageLoading ? null :
        <>
          <BackArrow fallbackPath="/clients-users/clients" fallbackTitle={t("CLIENTS")}/>
          <HeadWrapper>
            <Typography variant='h1'>
              {client}
            </Typography>
          </HeadWrapper>
          <NavWrapper>
            <div>
              <Tabs
                tabs={tabs}
                size='display'
                location={activeTab}
                onChange={setActiveTab}
              />
            </div>
          </NavWrapper>
        </>
      }
      <Routes>
        <Route index element={<Navigate replace to="details" />} /> 
        <Route path='details' element={<Details/>}/>
        <Route path='users' element={<Users/>}/>
        <Route path='invoices' element={<Invoices/>}/>
        <Route path='journal' element={<Journal/>}/>
        <Route path='billing-history' element={<BillingHistory/>}/>
        <Route path='cloud-resources' element={<CloudResources/>}/>
        <Route path='services' element={<Services/>}/>
        <Route path='openstack-service' element={<OpenstackService/>}/>
        <Route path='email-log' element={<EmailLog/>}/>
        <Route path='log' element={<ClientLog/>}/>
      </Routes>
    </Container>
  )
}

export default ClientPage
